// src/sanityClient.js
import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID
const dataset = process.env.REACT_APP_SANITY_DATASET || 'production'
const apiVersion = '2023-07-01'
const useCdn = true  // browser should use CDN for fast cached reads

if (!projectId) {
  throw new Error(
    'Missing REACT_APP_SANITY_PROJECT_ID. Did you set it in Netlify environment variables?'
  )
}

export const client = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn,
})

const builder = imageUrlBuilder(client)
export const urlFor = (source) => builder.image(source)
